/* @flow */
import React, { useEffect } from 'react';
import Routes from '../index';
import styles from './App.module.pcss';
import { useIdleTimer } from 'react-idle-timer';
import { timeOutMinutes } from '@/config/defaultConfig';

type Props = {
  checkToken: () => Promise<any>,
  fetchOrganizations: () => Promise<any>,
  auth: AuthT,
  signOut: () => void,
};

function App(props: Props) {
  const {
    checkToken,
    auth: { isAuthorized },
    fetchOrganizations,
    signOut,
  } = props;

  useEffect(() => {
    var lastAccessTime = localStorage.getItem('lastAccessTime');
    var now = new Date().getTime();
    if (now - lastAccessTime > timeOutMinutes * 60 * 1000) {
      signOut();
    } else {
      checkToken();
    }
  }, [checkToken]);

  useEffect(() => {
    if (isAuthorized) {
      fetchOrganizations();
    }
  }, [fetchOrganizations, isAuthorized]);

  const handleOnIdle = () => {
    signOut();
  };

  const handleOnAction = () => {
    reset();
    var now = new Date().getTime();
    localStorage.setItem('lastAccessTime', now);
  };

  const { reset } = useIdleTimer({
    timeout: timeOutMinutes * 60 * 1000,
    onIdle: handleOnIdle,
    onAction: handleOnAction,
  });

  return (
    <div className={styles.app}>
      <Routes authProps={props} />
    </div>
  );
}

export default App;
